/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VoucherEmissioneRigaFallitaDTO { 
    /**
     * Id della riga di graduatoria
     */
    id_graduatoria_riga?: string;
    /**
     * Id della pratica
     */
    id_pratica?: string;
    /**
     * Codice della pratica, per ritrovarla nell\'interfaccia
     */
    codice_pratica?: string;
    /**
     * Messaggio dell\'errore che ha impedito l\'emissione
     */
    motivo?: string;
}

